const external_link = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10%205V7H5V19H17V14H19V19C19%2020.1046%2018.1046%2021%2017%2021H5C3.89543%2021%203%2020.1046%203%2019V7C3%205.89543%203.89543%205%205%205H10ZM20.9971%203V11H18.9971V6.41421L11.7042%2013.7071L10.29%2012.2929L17.5829%205H12.9971V3H20.9971Z'/%3e%3c/svg%3e";
export {
  external_link as default
};
//# sourceMappingURL=external_link.svg.es.js.map
